import * as React from 'react';
import {Map} from "../components/Map";
import {DrawText} from "../components/DrawText";
import {MainBanner} from "../components/banners/MainBanner";
import {newsStore} from "../store";
import {browserHistory} from "react-router";
import {historyState} from "../helpers";

interface NewsReadProps {
    params: {
        [key: string]: string;
    }
}

export class NewsRead extends React.Component<NewsReadProps, any> {
    render() {
        const item = newsStore.findById(this.props.params['id']);
        const back = (e) => {
            e.preventDefault();
            if (historyState.pushes > 0 ) {
                browserHistory.goBack()
            } else {
                browserHistory.push('/');
            }
        };
        
        return (
            <div>
                <MainBanner compact />
                <section className="news-read">
                    <a href="#" onClick={back} className="back">Вернуться назад</a>
                    <article>
                        <b>{item.date}</b>
                        <h2>{item.title}</h2>
                        <DrawText data={item.description} />
                    </article>
                </section>
                <div className="row">
                    <Map />
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/NewsRead.tsx
 **/